import { vec3 } from "gl-matrix";
import { Component, Object3D } from "@wonderlandengine/api";
import { property } from "@wonderlandengine/api/decorators.js";
import { TouchUI } from "./touch-ui.js";

const _direction = new Float32Array(3);
const _tempDualQuat = new Float32Array(8);

/**
 * Basic movement with touch events on the left half of the screen.
 */
export class TouchMove extends Component {
  static TypeName = "touch-move";

  @property.float(0.1)
  speed = 0.1;

  @property.bool(false)
  lockY = false;

  @property.object()
  headObject: Object3D | null = null;

  @property.object({ required: true })
  touchUIComponent!: Object3D;

  private touchUI!: TouchUI;

  start() {
    this.headObject = this.headObject || this.object;

    const tempTouchUI = this.touchUIComponent.getComponent(TouchUI);
    if (!tempTouchUI) {
      throw new Error(
        `touch-move(${this.object.name}): touchUIComponent does not have a TouchUI`,
      );
    }
    this.touchUI = tempTouchUI;
  }

  update() {
    if (!this.touchUI.active || !this.touchUI.joystick1Value.isTouching) return;

    vec3.zero(_direction);
    _direction[0] = -this.touchUI.joystick1Value.x;
    _direction[2] = this.touchUI.joystick1Value.y;

    vec3.normalize(_direction, _direction);
    _direction[0] *= this.speed;
    _direction[2] *= this.speed;

    vec3.transformQuat(
      _direction,
      _direction,
      this.headObject!.getTransformWorld(_tempDualQuat),
    );

    if (this.lockY) {
      _direction[1] = 0;
      vec3.normalize(_direction, _direction);
      vec3.scale(_direction, _direction, this.speed);
    }

    this.object.translateLocal(_direction);
  }
}
